import yup from '../../../config/yup';

export const element451ReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('element451Reader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    client: yup
      .string()
      .required('Client is required')
      .transform((value) => value?.trim()),
    api: yup.string().transform((value) => value?.trim()),
    taskGUID: yup
      .string()
      .required('TaskGUID is required')
      .transform((value) => value?.trim()),
    feature: yup
      .string()
      .required('Feature is required')
      .transform((value) => value?.trim()),
    perPage: yup.number(),
    showSchema: yup.boolean(),
    isRetry: yup.boolean(),
    sleepInMilliSeconds: yup.number(),
    retryCount: yup.number(),
  }),
});
